export default "<ngx-loading-x [show]=\"carregando\"></ngx-loading-x>\n";